import { createContext, useContext } from "react";

export const SupportChatContext = createContext<
  | {
      openSupportChat: () => void;
    }
  | undefined
>(undefined);

export const useSupportChat = () => {
  const ctx = useContext(SupportChatContext);
  if (!ctx) {
    throw new Error("useSupportChat must be used within SupportChatProvider");
  }

  return ctx.openSupportChat;
};
